import * as z from "zod/v4";

export const MerchantProcessingDataSchema = z.object({
  merchantName: z.string(),
  totalReturns: z.number(),
  totalItems: z.number(),
  avgProcessingTimeHours: z.number(),
});

export type MerchantProcessingData = z.infer<
  typeof MerchantProcessingDataSchema
>;

export const getReturnsProcessingByMerchant = {
  name: "getReturnsProcessingByMerchant" as const,
  input: z.object({ startDate: z.coerce.date(), endDate: z.coerce.date() }),
  output: z.object({ merchants: z.array(MerchantProcessingDataSchema) }),
};
